'use client';

import React, { createContext, useContext } from 'react';
import useTransactionTypes from '@dm-portal/transaction-types/useTransactionTypes';
import { useDataroomTenantContext } from '@dataroom/tenant/DataroomTenantContext';

const useTransactionType = () => {
  const { tenant } = useDataroomTenantContext();
  return useTransactionTypes(tenant);
};

type TransactionTypeContextType = ReturnType<typeof useTransactionType>;

export const TransactionTypeContext = createContext<TransactionTypeContextType | null>(null);

export const useTransactionTypeContext = (): TransactionTypeContextType => {
  const context = useContext(TransactionTypeContext);
  if (!context) {
    throw new Error('useTransactionTypeContext must be used within a TransactionTypeContextProvider');
  }
  return context;
};

interface IProps {
  children: React.ReactNode,
}

const TransactionTypeContextProvider = ({ children }: IProps) => (
  <TransactionTypeContext.Provider value={ useTransactionType() }>
    { children }
  </TransactionTypeContext.Provider>
);

export default TransactionTypeContextProvider;
